import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import  { useState } from "react";
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ReceiptRoundedIcon from '@mui/icons-material/FormatListNumbered';



const StackAvailableReelListSubMenu = ({  selectedButtonName, setSelectedButtonName,handlecallProcess }) => {

    const [selectedButton, setSelectedButton] = useState(selectedButtonName);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);
        
        handlecallProcess(buttonName);
    };
    return (

        <Grid container display="flex-start"  padding={0}>

            {/* Add Button */}
            {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} /> */}
            {/* <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Back to menu">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('selectAll')}  >
                            <ModeEditOutlineOutlinedIcon style={{ fontSize:"18px" ,color: selectedButton === 'selectAll' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Reject Parent Roll</Typography>
                        </IconButton>
                        
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
            {/* Add Button */}
            {/* <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Email')}>
                            <EmailOutlinedIcon style={{ fontSize:"18px" ,color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Send Mail</Typography>
                        </IconButton>
                       
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('StackingReels')}>
                            <ReceiptRoundedIcon style={{fontSize:"18px" , color: selectedButton === 'StackingReels' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Stacking Reels List</Typography>
                        </IconButton>
                       
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
           
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('PDF')}>
                            <PictureAsPdfOutlinedIcon style={{fontSize:"18px" , color: selectedButton === 'PDF' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Download</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>PDF/Print</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('All Reel')}>
                            <PictureAsPdfOutlinedIcon style={{fontSize:"18px" , color: selectedButton === 'All Reel' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Show All Reel Details</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>PDF/Print</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('WinderMachine')}>
                            <ExitToAppRoundedIcon style={{fontSize:"18px" , color: selectedButton === 'WinderMachine' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Winder Machine Production</Typography>
                        </IconButton>
                        
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
            
            
        </Grid>



    )
};
export default StackAvailableReelListSubMenu;